// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"f7c3edf1","48":"872b6f8a","160":"a0b8148b","208":"847e910d","293":"5a3c25d4","432":"8954df6c","453":"052877a7","510":"8904a454","516":"e135cb3c","519":"0a894c04","811":"6126dbc6","906":"b1ceedbb","917":"0d23ab2d","946":"751fa67f","947":"9b818b90"}[chunkId] + ".chunk.js";
};